// extracted by mini-css-extract-plugin
module.exports = {"verticalTable":"styles__verticalTable___ZtK3R"};